class ArrayUtils {
  static indexOf(arr, val) {
    if (!Array.isArray(arr)) {
      return -1;
    }
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === val) return i;
    }
    return -1;
  };
  static remove(arr, val) {
    if (!Array.isArray(arr)) {
      return arr;
    }
    let index = this.indexOf(arr, val);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };
  static sum(arr) {
    if (!Array.isArray(arr)) {
      return undefined;
    }
    if (arr.length === 0) {
      return 0;
    }
    let result = arr[0];
    let length = arr.length;
    for (let i = 1; i < length; i++) {
      result += arr[i];
    }
    return result;
  }
  static contains(arr, x) {
    let result = false;
    if (!Array.isArray(arr)) {
      //console.log('container is not Array')
      return result;
    }
    let length = arr.length;
    //console.log('container array len:'+length)
    if (length === 0) {
      return result;
    }
    for (let i = 0; i < length; i++) {
      if (arr[i] === x) {
        return true;
      }
    }
    return result;
  }
  static avg(arr) {
    let result = 0;
    if (!Array.isArray(arr)) {
      return result;
    }
    let length = arr.length;
    if (length === 0) {
      return result;
    }
    result = ArrayUtils.sum(arr) / length;
    return result;
  }
  static hasNext(arr) {
    let result = false;
    if (!Array.isArray(arr)) {
      return result;
    }
    result = arr.length > 0;
    return result;
  }
  static shuffle(arr) {
    if (!Array.isArray(arr)) {
      return arr;
    }
    let length = arr.length;
    for (let i = 0; i < length; i++) {
      let pos = parseInt(Math.random() * (length - i) + '');
      let save = arr[i];
      arr[i] = arr[pos];
      arr[pos] = save;
    }
    return arr;
  }
  static unique(arr) {
    if (!Array.isArray(arr)) {
      return arr;
    }
    let u = [];
    let length = arr.length;
    for (let i = 0; i < length; i++) {
      let o = arr[i];
      if (!ArrayUtils.contains(u, o)) {
        u.push(o);
      }
    }
    return u;
  }
  static min(arr) {
    let result = 0;
    if (!Array.isArray(arr)) {
      return result;
    }
    let length = arr.length;
    if (length === 0) {
      return result;
    }
    result = arr[0];
    for (let i = 1; i < length; i++) {
      let o = arr[i];
      if (o < result) {
        result = o;
      }
    }
    return result;
  }
  static max(arr) {
    let result = 0;
    if (!Array.isArray(arr)) {
      return result;
    }
    let length = arr.length;
    if (length === 0) {
      return result;
    }
    result = arr[0];
    for (let i = 1; i < length; i++) {
      if (arr[i] > result) {
        result = arr[i];
      }
    }
    return result;
  }
}

exports = module.exports = {
  ArrayUtils: ArrayUtils
};



//////////////////
// WEBPACK FOOTER
// ./static/js/ArrayUtils.js
// module id = Qp4Y
// module chunks = 16